import React, {Component} from 'react';
import ModalWrapper from "../ModalWrapper";
import "./styles/AAFModalTelmexEditPaymentMethod.scss";
import Button from "../../Button";
import Translator from "../../../requests/apa/Translator";
import Utils from "../../../utils/Utils";
import store from "../../../store";
import { HIDE_MODAL, showModal } from "../../../actions/modal";

class AAFModalTelmexEditPaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.keysMetadata = {
      texto_title: "MDP_MetodosDePago_ModalQREditarMDP_Texto_Titulo",
      texto_Parrafo1: "MDP_MetodosDePago_ModalQREditarMDP_Texto_Parrafo1",
      texto_Parrafo2: "MDP_MetodosDePago_ModalQREditarMDP_Texto_Parrafo2",
      texto_ListaParte1: "MDP_MetodosDePago_ModalQREditarMDP_Texto_Lista_Parte1",
      texto_ListaParte2: "MDP_MetodosDePago_ModalQREditarMDP_Texto_Lista_Parte2",
      texto_ListaParte3: "MDP_MetodosDePago_ModalQREditarMDP_Texto_Lista_Parte3",
      texto_Parrafo3: "MDP_MetodosDePago_ModalQREditarMDP_Texto_Parrafo3",
      texto_EnlaceTextoAgregarMDP: "MDP_MetodosDePago_ModalQREditarMDP_Enlace_Texto_EditarMDP",
      
      texto_Parrafo4Parte1:"MDP_MetodosDePago_ModalQREditarMDP_Texto_Parrafo4_Parte1",
      texto_Parrafo4Parte2:"MDP_MetodosDePago_ModalQREditarMDP_Texto_Parrafo4_Parte2",
      texto_Parrafo4Parte3:"MDP_MetodosDePago_ModalQREditarMDP_Texto_Parrafo4_Parte3",
      texto_Parrafo4Parte4:"MDP_MetodosDePago_ModalQREditarMDP_Texto_Parrafo4_Parte4",
      texto_accept: "MDP_Boton_Texto_Aceptar"
    };
    this.state = {
      text: {
        texto_title: Translator.get(this.keysMetadata.texto_title),
        texto_Parrafo1: Translator.get(this.keysMetadata.texto_Parrafo1 ),
        texto_Parrafo2: Translator.get(this.keysMetadata.texto_Parrafo2),
        texto_ListaParte1: Translator.get(this.keysMetadata.texto_ListaParte1 ),
        texto_ListaParte2: Translator.get(this.keysMetadata.texto_ListaParte2),
        texto_ListaParte3: Translator.get(this.keysMetadata.texto_ListaParte3),
        texto_Parrafo3: Translator.get(this.keysMetadata.texto_Parrafo3),
        texto_EnlaceTextoAgregarMDP: Translator.get(this.keysMetadata.texto_EnlaceTextoAgregarMDP),

        texto_Parrafo4Parte1: Translator.get(this.keysMetadata.texto_Parrafo4Parte1),
        texto_Parrafo4Parte2: Translator.get(this.keysMetadata.texto_Parrafo4Parte2),
        texto_Parrafo4Parte3: Translator.get(this.keysMetadata.texto_Parrafo4Parte3),
        texto_Parrafo4Parte4: Translator.get(this.keysMetadata.texto_Parrafo4Parte4),
        texto_accept: Translator.get(this.keysMetadata.texto_accept)
      },
      numChars: {
        texto_title: 36,
        texto_Parrafo1: 41,
        texto_Parrafo2: 38,
        texto_ListaParte1: 35,
        texto_ListaParte2: 35,
        texto_ListaParte3: 35,
        texto_Parrafo3: 38,
        texto_EnlaceTextoAgregarMDP: 38,
        texto_Parrafo4Parte4: 29,
        texto_accept: 10
      }
    };
    this.qrCode = props.response && props.response.dataLinkSeesion && props.response.dataLinkSeesion.qrCode;
    console.log("this.qrCode", this.qrCode);
  }

  componentDidMount(){
        //this.startPolling();
  }

  cutString() {
    const texts = this.state.text;
    const numChars = this.state.numChars;
    const keysTexts = Object.keys(texts);

    keysTexts.forEach((key) => {
      if (texts[key] !== this.keysMetadata[key]) {
        texts[key] = Utils.cutPlayerString(texts[key], numChars[key], null, "...");
      }
    });

    return texts
  }

  handleAccept = () => {
    store.dispatch(showModal({
      modalType: HIDE_MODAL,
      modalProps: {}
    }))
  }

  handleBack = () => {
    store.dispatch(showModal({
      modalType: HIDE_MODAL,
      modalProps: {}
    }));
  }

  render() {
    const {
        texto_title,
        texto_Parrafo1,
        texto_Parrafo2,
        texto_ListaParte1,
        texto_ListaParte2,
        texto_ListaParte3,
        texto_Parrafo3,
        texto_EnlaceTextoAgregarMDP,
        texto_Parrafo4Parte1,
        texto_Parrafo4Parte2,
        texto_Parrafo4Parte3,
        texto_Parrafo4Parte4,
        texto_accept
    } = this.cutString();

    return (
      <ModalWrapper className={"modal-telmex-edit-method-payment"} callbackWhenBack={this.handleBack}>
        <div className="modal-content-edit-method-payment">
          <div className="modal-content-edit-method-payment-head">
            <div className="head-title">
              <div className={"head-title-text"}>{texto_title}</div>
            </div>
            <div className="head-title">
              <div className={"head-subtitle-text"}></div>
            </div>
          </div>
          <div className="modal-content-edit-method-payment-body">
            <div className="body-column body-column-left">
              <div className="body-section-title">
                {texto_Parrafo1}
              </div>
              <div className="body-section-subtitle">
                {texto_Parrafo2}
              </div>
              <ul className="body-list">
                <li>{texto_ListaParte1}</li>
                <li>{texto_ListaParte2}</li>
                <li>{texto_ListaParte3}</li>
              </ul>
              <div className="body-link">
                {texto_Parrafo3}
              </div>
              <div className="body-link-url">
                {texto_EnlaceTextoAgregarMDP}
              </div>
            </div>
            <div className="body-divider" />
            <div className="body-column body-column-right">
              <div className="body-section-title">
                {texto_Parrafo4Parte1}{" "}
                <span className="body-link-highlight">
                  {texto_Parrafo4Parte2}
                </span>{" "}
                {texto_Parrafo4Parte3}{" "}
               {texto_Parrafo4Parte4}
                
              </div>
              <div className="body-qr">
                <img src={this.qrCode} alt="QR"/>
              </div>
            </div>
          </div>
          <div className="modal-footer-message">
            <Button
              activate
              id="acceptButton"
              type="button"
              variant="primary"
              className={"primaryButton focusable"}
              text={texto_accept}
              onClick={this.handleAccept}
            />
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default AAFModalTelmexEditPaymentMethod;



// WEBPACK FOOTER //
// ./src/components/Modal/Telmex/AAFModalTelmexEditPaymentMethod.jsx